var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ height: "18", viewBox: "0 0 21 18", width: "21", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M-9.401-11h40v40h-40z" }),
      React.createElement("path", { d: "M9.302 3.13h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1z", stroke: "currentColor" }),
      React.createElement("path", { d: "M15.302 5.13h3v2h-3zm-4 0h3v2h-3zm4 3h3v2h-3zm-4 0h3v2h-3zm4 3h3v2h-3zm-4 0h3v2h-3z", fill: "currentColor" }),
      React.createElement("path", { d: "M2.127 2.953l9-1.606a1 1 0 0 1 1.175.984v13.32a1 1 0 0 1-1.175.984l-9-1.606a1 1 0 0 1-.825-.985V3.938a1 1 0 0 1 .825-.985z", fill: "#f4f4f4", stroke: "currentColor" }),
      React.createElement("path", { d: "M3.176 13l2.387-3.905-2.398-3.96h2.189l.858 1.617c.264.495.484 1.012.484 1.012h.022s.209-.506.484-1.012l.869-1.617h2.189l-2.409 3.96L10.249 13H8.104l-.902-1.65a12.443 12.443 0 0 1-.484-.979h-.022s-.209.484-.484.979L5.31 13z", fill: "currentColor" })
    )
  );
});